import {
    FETCH_MASTER_DATA_REQUEST,
    FETCH_MASTER_DATA_SUCCESS,
    FETCH_MASTER_DATA_FAILURE,
  } from './masterDataTypes'
/*   import {getLoginUser} from '../../_services/user/getLoginUser.service'
  import {getUserId} from '../../_helpers/auth/secureToken' //to pass the user id  */
import { getGenre, getLanguage } from '../../_services/profile'
import { moodRequest } from '../../_services/profile/mood.service'
import { subgenreRequest } from '../../_services/profile/subgenre.service'
import { contentTypeRequest } from '../../_services/submitAsong/contentType.service'
  
  export const fetchMasterData = () => {
    let masterData;
    return (dispatch) => {
      dispatch(fetchMasterDataRequest())
        getGenre()
        .then((response)=>{
            masterData = {...masterData,genre:response.data.data}
            dispatch(fetchMasterDataSuccess(masterData))
        })
        moodRequest()
        .then((response)=>{
            masterData = {...masterData,mood:response.data.data}
            dispatch(fetchMasterDataSuccess(masterData))
        })
        getLanguage()
        .then((response)=>{
            masterData = {...masterData,language:response.data.data}
            dispatch(fetchMasterDataSuccess(masterData))
        })
        // subgenreRequest()
        // .then((response)=>{
        //     masterData = {...masterData,subGenre:response.data.data}
        //     dispatch(fetchMasterDataSuccess(masterData))
        // })
        // contentTypeRequest({},'GET')
        // .then((response)=>{
        //     masterData = {...masterData,contentType:response.data.data}
        //     dispatch(fetchMasterDataSuccess(masterData))
        // })
        .catch(error=>error)
    }
  }
  
  export const fetchMasterDataRequest = () => {
    return {
      type: FETCH_MASTER_DATA_REQUEST
    }
  }
  
  export const fetchMasterDataSuccess = masterData => {
    return {
      type: FETCH_MASTER_DATA_SUCCESS,
      payload: masterData
    }
  }
  
  export const fetchMasterDataFailure = error => {
    return {
      type: FETCH_MASTER_DATA_FAILURE,
      payload: error
    }
  }
  